import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiClientService } from '../../core/api/api-client.service';
import { CertificateStatus, PublicCertificateVerification } from '../../core/models/portal.models';

@Component({
  selector: 'app-public-certificate-verification-page',
  standalone: true,
  templateUrl: './public-certificate-verification-page.component.html'
})
export class PublicCertificateVerificationPageComponent implements OnInit {
  private readonly api = inject(ApiClientService);
  private readonly route = inject(ActivatedRoute);

  protected readonly certificate = signal<PublicCertificateVerification | null>(null);
  protected readonly error = signal(false);

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.error.set(true);
      return;
    }

    this.api.publicCertificateVerification(token).subscribe({
      next: (certificate) => this.certificate.set(certificate),
      error: () => this.error.set(true)
    });
  }

  protected formatDate(value: string | null): string {
    if (!value) {
      return 'Ohne Ablaufdatum';
    }

    return new Intl.DateTimeFormat('de-DE', { dateStyle: 'long' }).format(new Date(value));
  }

  protected statusLabel(status: CertificateStatus): string {
    const labels: Record<CertificateStatus, string> = {
      ISSUED: 'Ausgestellt',
      VALID: 'Gültig',
      EXPIRED: 'Abgelaufen',
      REVOKED: 'Widerrufen'
    };

    return labels[status] ?? status;
  }
}
